export var toSentenceCase = function (phrase) {
    var lowercasePhrase = phrase.toLowerCase();
    var words = lowercasePhrase.split(' ');
    var sentenceCaseWords = [];
    words.forEach(function (word) {
        sentenceCaseWords.push("".concat(word.charAt(0).toLocaleUpperCase()).concat(word.slice(1)));
    });
    return sentenceCaseWords.join(' ');
};
export var sentenceToCamelCase = function (phrase) {
    var words = phrase.split(' ');
    var camelCaseWords = [];
    words.forEach(function (word) {
        if (camelCaseWords.length === 0) {
            camelCaseWords.push(word.toLocaleLowerCase());
            return;
        }
        camelCaseWords.push(toSentenceCase(word));
    });
    return camelCaseWords.join('');
};
export var stripHtmlTags = function (input) {
    var div = document.createElement('div');
    div.innerHTML = input;
    div.querySelectorAll('a').forEach(function (a) { return a.remove(); });
    div.querySelectorAll('img').forEach(function (img) { return img.remove(); });
    // Replace <p> with <br>, remove </p>
    var html = div.innerHTML
        .replace(/<br\s*\/?>/gi, ' ')
        .replace(/<p[^>]*>/gi, '') // remove opening <p>
        .replace(/<\/p>/gi, '<br>') // replace closing </p> with <br>
        .replace(/&nbsp;/gi, ' ') // normalize &nbsp;
        .replace(/<br\s*\/?>/gi, '<br>') // normalize <br> tags
        .replace(/(<br>\s*){2,}/gi, '<br>') // collapse multiple <br>
        .trim();
    // Remove leading/trailing <br>
    html = html.replace(/^<br>\s*/i, '').replace(/\s*<br>$/i, '');
    return html;
};
export var measureLinesFromHtml = function (element) {
    var ranges = Array.from(element.childNodes).map(function (node) {
        var range = document.createRange();
        range.selectNodeContents(node);
        return range.getClientRects();
    });
    var rects = ranges.flatMap(function (rectList) { return Array.from(rectList); });
    var uniqueLineYs = new Set(rects.map(function (r) { return r.top; }));
    return uniqueLineYs.size;
};
